import { Player } from "@lottiefiles/react-lottie-player";
import { Clock } from "react-bootstrap-icons";

export default function NetworkError() {
    // states


    // comportements
    const handlerefresh = () => {
        window.location.reload();
    }


    // affichage
    return (
        <div className="uk-uk-child-width-1-1 uk-grid" style={{height: "88vh"}}>
            <div className="mb-3 mt-5">
                <Player
                    autoplay
                    loop
                    src="/assets/imgs/network_error.json"
                    style={{ height: '296px', width: '296px', display: "block", marginLeft: "auto", marginRight: "auto", marginTop: 136 }}
                    >
                </Player>
            </div>
            <div className="mb-3 p-3 text-center">
                <p className='text-center text-dark' style={{fontSize: 20}}>Service unavailable at the moment! Try again later.</p>
                <button onClick={handlerefresh} className="btn btn-primary">
                    <Clock style={{marginRight: 8}}/> Refresh 
                </button>
            </div>
        </div>
    )
}